const user = 'user@test.com'
const verified_user = 'verified_user@test.com'
const organization = 'organization@test.com'
const password = '123456'

const DATA_KEY = 'khub_data'
export const TOKEN_KEY = 'khub_token'

const auth = () => {
  const check = (form) => {
    return new Promise((resolve, reject) => {
      if(
        form.email === organization
        && form.password === password
      ){
        console.log('logged in as organization')
        resolve({
          status: 200,
          email: form.email,
          token: 'organization_dummy_token',
          role: 'organization'
        })
      }
      else if (
        form.email === verified_user
        && form.password === password
      ){
        console.log('logged in as verified_user')
        resolve({
          status: 200,
          email: form.email,
          token: 'verified_user_dummy_token',
          role: 'verified_user'
        })
      }
      else if (
        form.email === user
        && form.password === password
      ){
        console.log('logged in as user')
        resolve({
          status: 200,
          email: form.email,
          token: 'user_dummy_token',
          role: 'user'
        })
      }
      else {
        reject({
          status: 404,
          message: 'Email/password is wrong.'
        })
      }
    })
  }

  const logout = () => {
    localStorage.removeItem(DATA_KEY)
    localStorage.removeItem(TOKEN_KEY)
  }

  const getCurrentUser = () => {
    const data = localStorage.getItem(DATA_KEY)
    const parsed = data ? JSON.parse(data) : {}
    return parsed
  }

  const getAccountTypeId = (account) => {
    if(account && account.typeAccount){
      if(account.typeAccount.id){
        return account.typeAccount.id
      }
      return false
    }
    return false
  }

  const isOfficial = getCurrentUser() ? getCurrentUser().role === 'organization' : false
  const isVerified = getCurrentUser() ? getCurrentUser().role === 'verified_user' : false
  const isUser = getCurrentUser() ? getCurrentUser().role === 'user' : false

  const checkIfVerified = (type) => type === 1
  const checkIfOfficial = (type) => type === 2

  const setTokenToLocalStorage = (token) => localStorage.setItem(TOKEN_KEY, token)
  const getTokenFromLocalStorage = () => localStorage.getItem(TOKEN_KEY)

  return {
    check,
    logout,
    getCurrentUser,
    getAccountTypeId,
    isOfficial,
    isVerified,
    isUser,
    getTokenFromLocalStorage,
    setTokenToLocalStorage,
    checkIfVerified,
    checkIfOfficial
  }
}

export default auth
